<template>
    <div class="col-md-6 pull-right">
        <ul class="list-unstyled pull-right">
            <li v-for="programmer in programmers" class="b-admin-domains-filter__item">
                <label>
                    <input type="radio" :value="programmer.id"  v-model='chosen_programmer'>
                        {{ programmer.name }}
                </label>
            </li>
        </ul>
    </div>
</template>

<script>
    // component for filtering by programmers
    export default {
        props: ['programmers'],
        data: function () {
            return {
                chosen_programmer: null
            };
        },
        watch: {
            'chosen_programmer' : function(val) {
                this.$root.$emit('update-table', {
                    whereField: 'programmer',
                    whereValue: val,
                    operator: '=',
                    page: 1
                });
            }
        }
    };
</script>
